import { render, staticRenderFns } from "./CustomerPublisher.vue?vue&type=template&id=69305c89&scoped=true&"
import script from "./CustomerPublisher.vue?vue&type=script&lang=js&"
export * from "./CustomerPublisher.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPublisher.vue?vue&type=style&index=0&id=69305c89&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69305c89",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VBtn,VCol,VIcon,VOverlay})
